import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import * as moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-info-general',
  templateUrl: './info-general.component.html',
  styleUrls: ['./info-general.component.css']
})
export class InfoGeneralComponent implements OnInit {

  @Input() chantier;
  @Input() client;
  @Input() edit: Boolean;
  @Input() hidetitle: Boolean;
  @Input() add: Boolean;
  @Input() isTypeDetenteur: Boolean;


  @Output() clickadresse = new EventEmitter<any>();
  result: any[] = [];
  resultZone: any[] = [];
  resultLieu: any[] = [];
  resultCpVille: any[] = [];

  status: { iscp: boolean, isville: boolean } = { iscp: false, isville: false };
  adresseAutoBAK: Boolean = false;
  dataAdresseBAK: any[] = [];
  rows = [];
  societe: any = {};

  @ViewChild('maj') maj;
  @ViewChild('majClefRepartition') majClefRepartition;
  @ViewChild('majClefRepartitionVille') majClefRepartitionVille;
  @ViewChild('msg') msg;
  clesRepartitionSelected: any[] = [];
  listCodeVille: any[] = [];
  error = '';

  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    console.log('chant', this.isTypeDetenteur)
    const societe = this.common.local.getObject('paramSociete') || {};
    this.societe = societe;
    const site = this.common.getType('siteUtilisateur');
    const adresseAutoBAK = site['rechercheAdresse'] && (site['serviceAdresse'] &&
      site['serviceAdresse'].typeServiceAdresse &&
      site['serviceAdresse'].typeServiceAdresse.id === 2) ? true : false;
    this.adresseAutoBAK = (societe['rechercheAdresse'] && (societe['serviceAdresse'] &&
      societe['serviceAdresse'].typeServiceAdresse &&
      societe['serviceAdresse'].typeServiceAdresse.id === 2)) || adresseAutoBAK;
    this.chantier['dateFin'] = this.chantier['dateFin'] || moment('31/12/9999', 'DD/MM/YYYY').format('DD/MM/YYYY');
    this.chantier['dateDebut'] = this.chantier['dateDebut'] || moment().format('DD/MM/YYYY');
    this.searchPays();
    this.common.closeAllAutocomplete();
    const ctrl = this;
    setTimeout(function () {
      $('#firstfocus').focus();
      ctrl.common.closeAllAutocomplete();
    }, 700);

    if (!this.chantier.id) {
      this.chantier['paysObjet'] = {
        id: societe.pays ? societe.pays.id : 0
      };
    }

    this.chantier['listLieu'] = this.chantier['listLieu'] || [];
    // this.chantier['listLieu'].forEach(elt => {
    //   elt.libelleObjetEntite = elt.nom || '';
    //   this.rows.push(elt);
    // });
    // this.rows = [...this.rows];
    this.common.getDetailBak(this.adresseAutoBAK, this.chantier['clefBAK']);
    console.log("this.common.visibleChamp");
    console.log(this.common.visibleChamp);
  }

  searchPays(event?) {

    this.result = [];
    this.common.getType('typePays').forEach(elt => {
      const eventLowerCase = !!event ? event.toLowerCase() : '';
      const libelleToLowerCase = !!elt.libelle ? elt.libelle.toLowerCase() : '';
      if (libelleToLowerCase.startsWith(eventLowerCase) || libelleToLowerCase.toLowerCase().startsWith(eventLowerCase)) {
        elt.libelleObjetEntite = elt.libelle;
        this.result.push(elt);
        if (this.chantier['paysObjet'] && this.chantier['paysObjet'].id == elt.id) {
          this.chantier['paysObjet'] = elt;
          this.chantier['pays'] = elt.libelleObjetEntite;
        }
      }
    });
  }

  searchZone(event) {
    this.resultZone = [];
    this.common.getType('typezone').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.resultZone.push(elt);
      // }
    });
  }


  searchLieu(event?) {
    this.rows = [];
    if (this.chantier && this.chantier.id) {
      const param = 52;

      return this.common.appelComboK3Fct(param, event, [{
        nom: 'CLEF_CHANTIER', valeur: {
          'typeParam': 'int',
          'valeur': this.chantier.id || 0
        }
      }]).then(datas => {
        // $('#autocomplete').trigger('click');
        if (datas.data !== null) {
          this.rows = datas.data || [];
        } else {
          if (datas.message) {
            if (datas.message.includes('Utilisateur non authentifié')) {
              this.common.removeConnection();
            }
          }
        }
      });
    }
  }

  searchLieuMAJ() {
    this.rows = [];
    if (this.chantier && this.chantier.id) {
      const param = 52;

      return this.common.appelComboK3Fct(param, '', [{
        nom: 'CLEF_CHANTIER', valeur: {
          'typeParam': 'int',
          'valeur': this.chantier.id || 0
        }
      }]).then(datas => {
        // $('#autocomplete').trigger('click');
        if (datas.data !== null) {
          this.rows = datas.data || [];
          this.rows.forEach(elt => elt.nom = elt.nom || elt.libelleObjetEntite || '');
          this.common.openModal(this.modalService, this.maj);
        } else {
          if (datas.message) {
            if (datas.message.includes('Utilisateur non authentifié')) {
              this.common.removeConnection();
            }
          }
        }
      });
    }
  }

  searchCPVille(event, val?) {
    this.resultCpVille = [];
    const param = {
      'servlet': val ? 'DBCodePostalVilleGetListParCP' : 'DBCodePostalVilleGetListParVille',
      'module': 'Recylog',
      'type': 'string',
      'compression': 'false',
      'data': event
    };

    this.common.post('', { param: param }).then(datas => {
      val ? $('#cp').trigger('click') : $('#ville').trigger('click');
      this.resultCpVille = datas.data;
      if (!this.resultCpVille.length) {
        val ? this.change(false, val) : this.change(false);
      } else {
        if (event.length >= 2) {
          if (val) {
            if (!this.status.iscp) {
              this.toggleDropdown(val);
            }
          } else {
            if (!this.status.isville) {
              this.toggleDropdown();
            }
          }
        }
      }
    });
  }

  selectAdresse(item) {
    this.chantier.codePostal = item.codePostal;
    this.chantier.ville = item.ville;
    this.status.iscp = false;
    this.status.isville = false;
  }

  toggleDropdown(val?): void {
    val ? this.status.iscp = !this.status.iscp : this.status.isville = !this.status.isville;
  }

  change(value: boolean, val?): void {
    val ? this.status.iscp = value : this.status.isville = value;
  }

  copieAdresse() {
    this.clickadresse.emit();
  }

  searchAdresseBAK(event) {
    this.dataAdresseBAK = [];
    const param = {
      'servlet': 'DBGestionAdresseRecherche',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CHAINE_RECHERCHE': event
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataAdresseBAK = datas.data;
        this.dataAdresseBAK.forEach(elt => {
          elt.id = elt.clefBAK;
          elt.libelleObjetEntite = elt.label;
        });
      }
    });
  }

  setValueAdresseBAK(value, name?) {
    if (value && (!value.numero || (value.numero && value.numero === '0'))) {
      value.numero = '';
    }

    this.chantier['adresse1'] = `${value.numero || ''} ${value.suffixe || ''}`;
    this.chantier['adresse2'] = `${value.typeVoie || ''} ${value.nomVoie || ''}`;
    this.chantier['adresse3'] = '';
    this.chantier['codePostal'] = value.postcode;
    this.chantier['ville'] = value.city;
    this.chantier['clefBAK'] = value.clefBAK;
    if (this.societe['isBAKRI']) {
      this.chantier['complementAdresse1'] = value.batiment;
      this.chantier['complementAdresse2'] = value.etage;
      this.chantier['typeHabitat'] = value.typeHabitat || { id: 0 };
      this.chantier['refCadastrale'] = value.refCadastrale;
      this.chantier['numInvariant'] = value.numInvariant;
    }
    this.common.bak = value;
  }

  showInput(row, index?) {
    const ctrl = this;
    row.edit = true;
    row.nomAncienne = row.nom;
    setTimeout(function () {
      if (index) {
        ctrl.common.focusElement('#activite' + index);
      } else {
        ctrl.common.focusElement('#activite' + (ctrl.rows.length - 1));
      }
    }, 510);
  }

  cancel(row) {
    row.edit = false;
    if (row.add) {
      this.rows = this.rows.filter(elt => !elt.add);
    } else {
      row.nom = row.nomAncienne;
    }
  }

  addLigne() {
    this.rows.push({ id: this.rows.length + 1, add: true, edit: true });

    this.rows = [...this.rows];
    const ctrl = this;
    setTimeout(function () {
      if (ctrl.rows.length) {
        ctrl.common.focusElement('#activite' + ctrl.rows.length);
      } else {
        ctrl.common.focusElement('#activite' + (ctrl.rows.length - 1));
      }
    }, 510);
  }

  save(row) {
    if (!this.add) {
      if (row.add) {
        row.id = 0;
      }
      row.edit = false;
      delete row.add;
      row.nomclass = 'LieuChantier';

      const param = {
        'servlet': 'DBSaveLieuChantier',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          LIEU: row,
          CLEF_CHANTIER: {
            'typeParam': 'int',
            'valeur': this.chantier['id']
          }
        }
      };

      this.common.post('', { param: param }).then(datas => {
        if (datas.data) {
          row.id = datas.data.id || 0;
          row.libelleObjetEntite = row.nom;
        }
      });
    }
  }

  unLieuChantierSelected() {
    // S'il n'y a pas de valeur dans lieuChantierSelect c'était this.chantier.listLieu[0] qui était pris
    return this.chantier &&
      ((this.chantier.lieuChantierSelect && this.chantier.lieuChantierSelect.id) || this.chantier.listLieu.length);
  }

  getValueLieuSelected() {
    if (this.chantier && this.chantier.lieuChantierSelect && this.chantier.lieuChantierSelect.id) {
      return this.chantier.lieuChantierSelect.nom ?
        this.chantier.lieuChantierSelect.nom : (this.chantier.lieuChantierSelect.libelleObjetEntite || '');
    } else {
      return (this.chantier.listLieu && this.chantier.listLieu.length ? this.chantier.listLieu[0].nom || '' : '');
    }
  }

  setLieuChantierSelect(event) {
    this.chantier.lieuChantierSelect = event;
  }

  changerCP(item) {
    console.log(item);
    if (this.societe['zoneCommune']) {
      if (typeof item === 'object') {
        this.chantier['zone'] = item.zone || { id: 0, libelle: '' };
      }
    }
  }

  ouvrirPanneauMAJCircuit(nouveau?) {
    if (nouveau) {
      this.chantier.lieuChantierSelect = {
        id: 0,
        nom: '',
        listeClesRepartition: []
      };
    } else {
      if ((!this.chantier.lieuChantierSelect || !this.chantier.lieuChantierSelect.id) && this.chantier.listLieu && this.chantier.listLieu.length) {
        this.setLieuChantierSelect(this.chantier.listLieu[0]);
      }
    }

    if (!nouveau) {
      const param = {
        'servlet': 'DBGestionLieuChantier',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 1
          },
          'CLEF_LIEU_CHANTIER': {
            'typeParam': 'int',
            'valeur': this.chantier.lieuChantierSelect['id']
          },
        }
      };

      return this.common.post('', { param: param }, true).then(datas => {
        // $('#autocomplete').trigger('click');
        if (this.common.verifySession(datas) && datas.data) {
          this.chantier.lieuChantierSelect = datas.data || this.chantier.lieuChantierSelect;
          if (!this.chantier.lieuChantierSelect['listeClesRepartition']) {
            this.chantier.lieuChantierSelect['listeClesRepartition'] = [];
          }

          this.common.openModal(this.modalService, this.majClefRepartition);
        }
      });
    } else {
      if (!this.chantier.lieuChantierSelect['listeClesRepartition']) {
        this.chantier.lieuChantierSelect['listeClesRepartition'] = [];
      }

      this.common.openModal(this.modalService, this.majClefRepartition);
    }


  }

  deleteLigneClefRepartition(row) {
    if (this.chantier.lieuChantierSelect && this.chantier.lieuChantierSelect['listeClesRepartition']) {
      const temp = this.chantier.lieuChantierSelect['listeClesRepartition'].filter(elt => elt !== row);
      this.chantier.lieuChantierSelect['listeClesRepartition'] = temp;
    }
  }

  editLigneClefRepartition(row) {
    this.clesRepartitionSelected = row;
    this.clesRepartitionSelected['listeVilleClesRepartition'] = this.clesRepartitionSelected['listeVilleClesRepartition'] || [];

    const debut = moment(this.clesRepartitionSelected['dateDebut'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
    const fin = moment(this.clesRepartitionSelected['dateFin'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
    this.clesRepartitionSelected['modelDebut'] = this.common.parseDate(debut);
    this.clesRepartitionSelected['modelFin'] = this.common.parseDate(fin);

    this.common.openModal(this.modalService, this.majClefRepartitionVille);
  }

  addLigneClefRepartition() {
    this.chantier.lieuChantierSelect['listeClesRepartition'] = this.chantier.lieuChantierSelect['listeClesRepartition'] || [];
    this.chantier.lieuChantierSelect['listeClesRepartition'].push({
      id: 0,
      dateDebut: moment().format('DD/MM/YYYY HH:mm:ss'),
      dateFin: moment().format('DD/MM/YYYY HH:mm:ss'),
      listeVilleClesRepartition: []
    });
    this.chantier.lieuChantierSelect['listeClesRepartition'] = [...this.chantier.lieuChantierSelect['listeClesRepartition']];
  }

  deleteLigneVilleClefRepartition(row) {
    if (this.clesRepartitionSelected && this.clesRepartitionSelected['listeVilleClesRepartition']) {
      const temp = this.clesRepartitionSelected['listeVilleClesRepartition'].filter(elt => elt !== row);
      this.clesRepartitionSelected['listeVilleClesRepartition'] = temp;
    }
  }

  addLigneVilleClefRepartition() {
    this.clesRepartitionSelected['listeVilleClesRepartition'] = this.clesRepartitionSelected['listeVilleClesRepartition'] || [];
    this.clesRepartitionSelected['listeVilleClesRepartition'].push({
      id: 0,
      pourcentage: 0,
      codePostalVille: {
        id: 0,
        ville: '',
        codePostal: ''
      }
    });
    this.clesRepartitionSelected['listeVilleClesRepartition'] = [...this.clesRepartitionSelected['listeVilleClesRepartition']];
  }

  searchCodeVille($event) {
    if ($event) {
      this.dataAdresseBAK = [];
      const param = {
        'servlet': 'DBGestionCodePostalVille',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 4
          },
          'TERM': $event
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        // $('#autocomplete').trigger('click');
        if (this.common.verifySession(datas) && datas.data) {
          this.listCodeVille = datas.data;
        }
      });
    }
  }

  changeDateDebut(event, row) {
    if (moment(event).isValid()) {
      row['dateDebut'] = moment(event).format('DD/MM/YYYY HH:mm:ss');
    } else {
      row['dateDebut'] = moment().format('DD/MM/YYYY HH:mm:ss');
    }
  }

  changeDateFin(event, row) {
    if (moment(event).isValid()) {
      row['dateFin'] = moment(event).format('DD/MM/YYYY HH:mm:ss');
    } else {
      row['dateFin'] = moment().format('DD/MM/YYYY HH:mm:ss');
    }
  }

  saveClesRepartition() {
    // Test superposition date
    if (!this.hasDateOverLap()) {
      this.error = 'Il y a des périodes qui se croisent.';
      this.common.openModal(this.modalService, this.msg);
      return false;
    }

    this.common.closeModal();
    this.chantier.lieuChantierSelect.nomclass = 'LieuChantier';
    const param = {
      'servlet': 'DBGestionClesRepartition',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        LIEU_CHANTIER: this.chantier.lieuChantierSelect,
        OPERATION: {
          'typeParam': 'int',
          'valeur': 3
        },
        CLEF_CHANTIER: {
          'typeParam': 'int',
          'valeur': this.chantier.id
        }
      }
    };

    this.common.post('', { param: param }, true).then(datas => {
      if (datas.data) {
        // il faut actualiser this.chantier.lieuChantierSelect et this.chantier.listLieu
        const idLieuChantier = this.chantier.lieuChantierSelect.id || 0;
        const newListLieu = this.chantier.listLieu.filter(row => row.id == idLieuChantier); // enlever la ligne de la liste
        datas.data.libelleObjetEntite = datas.data.nom;
        newListLieu.push(datas.data); // réinséré la ligne MAJ (avec les ID depuis la DB)
        this.chantier.listLieu = newListLieu;
        this.chantier.lieuChantierSelect = datas.data;
      }
    });
  }

  hasDateOverLap() {
    const listeClesRepartition = this.chantier.lieuChantierSelect['listeClesRepartition'];
    const hasNoOverlap = this.checkDateNoOverlap(listeClesRepartition);
    return hasNoOverlap;
  }

  checkDateNoOverlap(dateRanges: any[]): boolean {
    for (let i = 0; i < dateRanges.length - 1; i++) {
      const rangeA = dateRanges[i];
      const startA = moment(rangeA.dateDebut, "DD/MM/YYYY");
      const endA = moment(rangeA.dateFin, "DD/MM/YYYY");

      for (let j = i + 1; j < dateRanges.length; j++) {
        const rangeB = dateRanges[j];
        const startB = moment(rangeB.dateDebut, "DD/MM/YYYY");
        const endB = moment(rangeB.dateFin, "DD/MM/YYYY");

        if ((startA.isSameOrBefore(endB) && endA.isSameOrAfter(startB)) ||
          (startB.isSameOrBefore(endA) && endB.isSameOrAfter(startA))) {
          return false; // Il y a un chevauchement
        }
      }
    }

    return true; // Aucun chevauchement trouvé
  }


}
